module.exports = __webpack_public_path__ + "static/img/ewm.8a8c159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm.png
// module id = 439
// module chunks = 4 5 6